<template>
    <v-layout row justify-center>
        <v-dialog
            v-model="dialog"
            persistent
            max-width="600px"
            transition="dialog-transition"
            content-class="v-dialog--large"
        >
            <v-card>
                <v-card-title class="teal darken-2">
                    <span class="title" style="color: #fff;">{{ $t("registration") }}</span>
                </v-card-title>

                <v-divider></v-divider>

                <v-progress-linear color="green" :indeterminate="true" v-if="progressBarVisible" class="ma-0 pa-0 progress-top"></v-progress-linear>

                <v-card-text style="min-height: 150px; max-height: calc(100vh - 210px); overflow-y: auto;" class="pa-0">
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs-12>
                                <v-expansion-panel v-if="showLicense" class="mb-2">
                                    <v-expansion-panel-content>
                                        <template v-slot:header>
                                            <div>{{ $t("licenseAgreement") }}</div>
                                        </template>
                                        <v-card>
                                            <v-card-text v-html="licenseText"></v-card-text>
                                        </v-card>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                                <a href="https://a-vektor.bitrix24.ru/~gFVwr" target="_blank" class="mt-2 pt-2">{{ $t("privacyPolicy") }}</a>
                            </v-flex>
                            <v-flex xs12>
                                <v-checkbox
                                    hide-details
                                    v-model="licenseAccepted"
                                    :disabled="progressBarVisible"
                                    :label="`${$t('acceptLicense')} *`"
                                ></v-checkbox>
                            </v-flex>
                            <v-flex xs12>
                                <v-checkbox
                                    class="mt-0 pt-0"
                                    hide-details
                                    v-model="policyAccepted"
                                    :disabled="progressBarVisible"
                                    :label="`${$t('acceptPolicy')} *`"
                                ></v-checkbox>
                            </v-flex>
                            <v-flex xs12>
                                <v-checkbox
                                    class="mt-0 pt-0"
                                    hide-details
                                    v-model="naturalPerson"
                                    :disabled="progressBarVisible"
                                    :label="$t('registrationAsNaturalPerson')"
                                ></v-checkbox>
                            </v-flex>
                            <v-flex xs12 sm6 md4>
                                <v-text-field
                                    v-model="lastName"
                                    :disabled="!licenseAccepted || !policyAccepted || progressBarVisible"
                                    :label="`${$t('lastName')} *`"
                                    required
                                    hide-details>
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md4>
                                <v-text-field
                                    v-model="firstName"
                                    :disabled="!licenseAccepted || !policyAccepted || progressBarVisible"
                                    :label="`${$t('firstName')} *`"
                                    required
                                    hide-details>
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md4>
                                <v-text-field
                                    v-model="middleName"
                                    :disabled="!licenseAccepted || !policyAccepted || progressBarVisible"
                                    :label="$t('middleName')"
                                    hide-details
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 v-if="!naturalPerson">
                                <v-text-field
                                    v-model="companyName"
                                    :disabled="!licenseAccepted || !policyAccepted || progressBarVisible"
                                    :label="`${$t('company')} *`"
                                    required
                                    hide-details
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="eMail"
                                    :disabled="!licenseAccepted || !policyAccepted || progressBarVisible"
                                    :label="`${$t('eMail')} *`"
                                    :rules="[rules.required, rules.eMail]"
                                    required
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                    v-model="password1"
                                    :disabled="!licenseAccepted || !policyAccepted || progressBarVisible"
                                    :label="`${$t('password')} *`"
                                    type="password"
                                    required
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                    v-model="password2"
                                    :disabled="!licenseAccepted || !policyAccepted || progressBarVisible"
                                    :label="`${$t('passwordConfirm')} *`"
                                    type="password"
                                    required
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <small>{{ $t("reCaptchaNoteP1") }}&nbsp;
                            <a href="https://policies.google.com/privacy" target="_blank">{{ $t("privacyPolicy")}}</a> {{ $t("and") }}&nbsp;
                            <a href="https://policies.google.com/terms" target="_blank">{{ $t("termsOfService") }}</a>{{ $t("reCaptchaNoteP2") }}.
                        </small>
                        <v-divider class="mt-2"/>
                        <small>{{ $t("requiredFieldPointer") }}</small>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions :class="{'grey lighten-4': !this.$vuetify.dark, 'grey darken-4': this.$vuetify.dark}">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="success"
                        :disabled="!licenseAccepted || !policyAccepted || progressBarVisible"
                        @click="register"
                    >{{ $t("registration") }}</v-btn>
                    <v-btn
                        color="error"
                        :disabled="progressBarVisible"
                        @click="closeDialog"
                    >{{ $t("cancel") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <message-box ref="MessageBox"/>
    </v-layout>
</template>

<script>
    import MessageBox from "./MessageBox";

    export default {
        name: "RegistrationDialog",

        components: {
            MessageBox
        },

        data () {
            return {
                dialog:             false,
                showLicense:        false,
                licenseAccepted:    false,
                licenseText:        "",
                policyAccepted:     false,
                policyText:         "",

                firstName:          "",
                middleName:         "",
                lastName:           "",

                naturalPerson:      false,
                companyName:        "",
                eMail:              "",
                password1:          "",
                password2:          "",

                passwordsMatch:     true,

                recaptchaToken:     "",

                progressBarVisible: false,

                rules: {
                    required: value => !!value || this.$t("requiredField"),
                    eMail: value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || this.$t("invalidEMail")
                    }
                }
            }
        },

        watch: {
            password1: function (val) { this.passwordsMatch = val == this.password2; },
            password2: function (val) { this.passwordsMatch = this.password1 == val; },
        },

        async mounted () {
            // TODO recapctha, на данный момент не работает
            // await this.$recaptchaLoaded();
            // const recaptcha = this.$recaptchaInstance;
            // recaptcha.hideBadge();
        },

        methods: {
            closeDialog () {
                this.firstName          = "";
                this.middleName         = "";
                this.lastName           = "";
                this.companyName        = "";
                this.eMail              = "";
                this.password1          = "";
                this.password2          = "";
                this.naturalPerson      = false;
                this.licenseAccepted    = false;
                this.progressBarVisible = false;
                this.dialog             = false;
            },

            /**
             * Запуск процедуры регистрации
             */
            async register () {
                // this.recaptchaToken = await this.$recaptcha("login"); //await this.$recaptcha("register");

                if (!this.passwordsMatch) {
                    this.showMessageBox(this.$t("attention"), this.$t("passwordsMismatch"));
                } else if (this.password1.trim() == "") {
                    this.showMessageBox(this.$t("attention"), this.$t("passwordCantBeEmpty"));
                } else if (this.firstName == "" || this.lastName == "" || (this.companyName.trim() == "" && !this.naturalPerson) || this.eMail.trim() == "") {
                    this.showMessageBox(this.$t("attention"), this.$t("requiredFieldIsEmpty"));
                } else {
                    this.progressBarVisible = true;
                    this.axios({
                        method: "post",
                        url: `${this.$config.apiURL}register/`, //"users/register",
                        data: {
                            firstName:   this.firstName,
                            middleName:  this.middleName,
                            lastName:    this.lastName,
                            naturalPerson: this.naturalPerson,
                            companyName: this.companyName,
                            eMail:       this.eMail,
                            password:    this.password1,
                            // token:       this.recaptchaToken
                        },
                        //withCredentials: true
                    }).then(response => {
                        /*
                        this.firstName       = "";
                        this.middleName      = "";
                        this.lastName        = "";
                        this.companyName     = "";
                        this.eMail           = "";
                        this.password1       = "";
                        this.password2       = "";
                        this.licenseAccepted = false;
                        */

                        this.progressBarVisible = false;

                        if (response.data.status == "success") {
                            this.showMessageBox(this.$t("information"), this.$t("registrationSuccessful"));

                            this.closeDialog();
                            this.$emit("showAuth", true);

                            return;
                        }

                        /**
                         * Ответы
                         * ======
                         * Статус failure:
                         *   captcha_api_call_failed
                         *   captcha_check_negative
                         *   company_already_registered
                         *   company_name_is_empty
                         *   email_is_empty
                         *   email_is_disposable
                         *   password_is_empty
                         *   user_already_exists
                         */
                        switch (response.data.result) {
                            case "captcha_api_call_failed":
                                this.showMessageBox(this.$t("attention"), this.$t("captchaAPICallFailed"));
                                break;
                            case "captcha_check_negative":
                                this.showMessageBox(this.$t("attention"), this.$t("captchaCheckNegative"));
                                break;
                            case "company_already_registered":
                                this.showMessageBox(this.$t("attention"), this.$t("companyAlreadyRegistered"));
                                break;
                            case "user_already_exists":
                                this.showMessageBox(this.$t("attention"), this.$t("userAlreadyExists"));
                                break;
                            case "email_address_rejected":
                                this.showMessageBox(this.$t("attention"), this.$t("emailAddressRejected"));
                                break;
                            case "send_mail_error":
                                this.showMessageBox(this.$t("attention"), this.$t("sendMailError"));
                                break;
                            case "email_is_disposable":
                                this.showMessageBox(this.$t("attention"), this.$t("eMailIsDisposable"));
                                break;
                            case "success":
                                this.showMessageBox(this.$t("information"), this.$t("userRegistered"));
                                break;
                            default:
                                this.showMessageBox(this.$t("attention"), this.$t("registrationFailed"));
                        }
                    }).catch(() => {
                        this.progressBarVisible = false;

                        this.showMessageBox(this.$t("error"), this.$t("errorDuringRequest"));
                    });
                }
            },

            /**
             * Отображение сообщения
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            }
        }
    }
</script>
